<template>
    <div class="page rewardHistory">
        <TopNavBar/>
        <div class="container">
            <div class="historyList" v-if="rewHistList">
                <div class="el" v-for="elment in rewHistList">
                    <div class="leftCol">
                        <div class="date h5">
                            {{ dateTransform(elment.added) }}
                        </div>
                        <div class="title">
                            {{ elment.business_name }}
                        </div>
                        <div class="caption">
                            500 points remaining
                        </div>
                    </div>
                    <div class="minusPoints caption">
                        -{{ elment.points }}pts
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import TopNavBar from "../../components/shared/TopNavBar";

    export default {
        components: {TopNavBar},
        data(){
            return{
                rewHistList: null
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Rewards History", showBackButton: true, showBag: false}, {root: true});
            this.$store.dispatch("cart/getUserLoyaltyProfile",{
                callback: (res) => {
                    //console.log(res.data.history)
                    this.rewHistList = res.data.history;
                }
            })
        },
        methods: {
            dateTransform(date) {
                return moment(date).format("MMM DD [AT] h:mm a")
            },
        }
    }
</script>
